import {
  ComparisonOperator,
  FieldType,
  IEntityAttribute,
  LogicalOperator,
 AutomationVariableValue,
} from '.';

export enum ConditionType {
  COMPARISON = 'COMPARISON',
  LOGICAL = 'LOGICAL',
}

export interface IBaseCondition {
  type: ConditionType;
}

export interface IComparisonCondition extends IBaseCondition {
  type: ConditionType.COMPARISON;
  variableId: string;
  attribute: IEntityAttribute;
  op: ComparisonOperator;
  value: AutomationVariableValue;
  locked: boolean;
}

export interface ILogicalCondition extends IBaseCondition {
  type: ConditionType.LOGICAL;
  op: LogicalOperator;
  children: ICondition[];
  locked?: boolean;
}

// QUESTION(jb) should we extend IComparisonCondition with these fields
//              as optional like we do for IAutomationVariable?
export interface IComparisonConditionData extends IComparisonCondition {
  fieldType: FieldType;
  attributeValue: any;
}

export type ICondition = IComparisonCondition | ILogicalCondition;
